import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


export const content: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('@business/security/security.routes').then(r => r.securityRoutingModule)
      },

      {
        path: '',
        loadChildren: () => import('@business/main/main.routes').then(r => r.mainRoutingModule)
      },

      {
        path: '',
        loadChildren: () => import('@pages/configuration/configuration.routes').then(r => r.configurationRoutingModule)
      },

      {
        path: '',
        loadChildren: () => import('@pages/bulk-upload/bulk-upload.routes').then(r => r.bulkUploadRoutingModule)
      },

      {
        path: '',
        loadChildren: () => import('@business/monnet_v2/monnet.routes').then(r => r.monnetRoutingModule)
      },

      {
        path: '',
        loadChildren: () => import('@business/main/beneficiary/beneficiary.routes').then(r => r.beneficiaryRouteModule)
      },
      {
        path: '',
        loadChildren: () => import('@pages/notification/notification.routes').then(r => r.notificationRoutingModule)
      },
      {
        path: '',
        loadChildren: () => import('@business/report/report.routes').then(r => r.reportRoutingModule)
      },
      {
        path: '',
        loadChildren: () => import('@app/pages/report/report.routes').then(r => r.reportRoutingModule)
      },
    ],
  },
];
@NgModule({
  exports: [RouterModule],
})
export class ContentRoutingModule { }
